import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui'

const styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' }
    },
};

class Facilities extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="main__title">
                    facilities
                </div>

                <div className="facilities">
                    <div className="row divided">
                        <div className="col-xs-4 border-bottom">
                            <Field
                                name={'facilities.breakBulk'}
                                component={Checkbox}
                                label="Break Bulk"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.dryDock'}
                                component={Checkbox}
                                label="Dry Dock"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.roro'}
                                component={Checkbox}
                                label="Ro-Ro"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.container'}
                                component={Checkbox}
                                label="Container"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.lpg'}
                                component={Checkbox}
                                label="LPG"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.lng'}
                                component={Checkbox}
                                label="LNG"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.liquid'}
                                component={Checkbox}
                                label="Liquid"
                                labelStyle={styles.checkbox.labelStyle}
                            />  </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.multipurpose'}
                                component={Checkbox}
                                label="Multipurpose"
                                labelStyle={styles.checkbox.labelStyle}
                            />  </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.passenger'}
                                component={Checkbox}
                                label="Passenger"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.dryBulk'}
                                component={Checkbox}
                                label="Dry Bulk"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.bunkering'}
                                component={Checkbox}
                                label="Bunkering"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.steel'}
                                component={Checkbox}
                                label="Steel"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.shipyard'}
                                component={Checkbox}
                                label="Shipyard"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-4">
                            <Field
                                name={'facilities.reefer'}
                                component={Checkbox}
                                label="Reefer"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

Facilities.propTypes = {

};

Facilities.defaultProps = {

};

export default Facilities;


// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/Facilities.jsx